import { tryWithDefault } from "util/support";
import { toBooleanSwitch } from "util/casts";
import { BooleanSwitchValue } from "consts/general";
import useCountries from "features/general/useCountries";
import { ProfileInfo } from "ui/forms/Merchant";
import useMerchantDetail from "../../useMerchantDetail";

export default function useMerchantProfileInfo(): ProfileInfo.MerchantProfileInfoForm {
    const { merchant } = useMerchantDetail();
    const { countries, isCountriesLoading } = useCountries();

    const onSubmit = async (_: Partial<ProfileInfo.MerchantProfileInfo>) => {};

    const doNotBlacklistOnChargeback = tryWithDefault(() => (
        toBooleanSwitch(
            merchant.groupPivots[0]?.doNotBlacklistOnChargeback ?? BooleanSwitchValue.Off
        )
    ), BooleanSwitchValue.Off);

    const doNotBlacklistOnRefund = tryWithDefault(() => (
        toBooleanSwitch(
            merchant.groupPivots[0]?.doNotBlacklistOnRefund ?? BooleanSwitchValue.Off
        )
    ), BooleanSwitchValue.Off);

    return {
        ...ProfileInfo.useForm({
            initialValues: {
                ...merchant,
                doNotBlacklistOnChargeback,
                doNotBlacklistOnRefund,
            },
            onSubmit
        }),
        onSaveOrCreate: onSubmit,
        bootstrapData: {
            countries
        },
        isBootstrapDataLoading: isCountriesLoading,
    };
};
